export const recaptchaAction = 'contact_form_submit';

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const scriptId = 'google-recaptcha-v3';
let scriptPromise;

const waitUntilReady = () => new Promise((resolve, reject) => {
  window.grecaptcha.ready(() => {
    if (typeof window.grecaptcha.execute !== 'function') {
      reject(new Error('Spam protection did not finish loading. Please refresh and try again.'));
      return;
    }
    resolve(window.grecaptcha);
  });
});

const loadRecaptcha = () => {
  if (!siteKey) {
    return Promise.reject(new Error('This form is temporarily unavailable. Please email support@reportwerks.com.'));
  }
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Spam protection is only available in the browser.'));
  }
  if (window.grecaptcha) return waitUntilReady();
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.async = true;
      script.defer = true;
      script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}&trustedtypes=true`;
      document.head.appendChild(script);
    }
    script.addEventListener('load', () => waitUntilReady().then(resolve).catch(reject), { once: true });
    script.addEventListener('error', () => reject(new Error('Spam protection could not load. Please check your connection and try again.')), { once: true });
  });

  return scriptPromise;
};

export const getRecaptchaToken = async () => {
  const recaptcha = await loadRecaptcha();
  const token = await recaptcha.execute(siteKey, { action: recaptchaAction });
  if (!token) throw new Error('Spam protection could not verify this submission. Please try again.');
  return token;
};
